import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-10 md:py-16 bg-cream-white" data-id="element-47">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-48">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white border border-sage-green/30 rounded-2xl p-5 md:p-10 flex flex-col md:flex-row items-center gap-5 md:gap-8 shadow-sm" data-id="element-49">
          <div className="flex-shrink-0" data-id="element-50">
            <div className="w-18 h-18 md:w-24 md:h-24 rounded-full bg-sage-green/10 flex items-center justify-center" data-id="element-51">
              <ShieldCheck className="w-12 h-12 text-sage-green" data-id="element-52" />
            </div>
          </div>

          <div className="text-center md:text-left" data-id="element-53">
            <h3 className="text-2xl font-heading font-bold text-deep-charcoal mb-3" data-id="element-54">
              Garantía de Riesgo Cero: Probado o Reembolsado
            </h3>
            <p className="text-deep-charcoal/80 leading-relaxed" data-id="element-55">
              Tienes <strong data-id="element-56">7 días</strong> para revisar todo el material. Si
              no sientes que este es el manual de instrucciones que tu cuerpo
              siempre necesitó, te devolvemos el 100% de tu dinero. Sin
              preguntas. El riesgo es mío.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}